import { ViewName } from '@typesApp/ViewNavigation'
import { ROUTES } from '@constants/index'
import { config } from '@config/config'

type ViewFlow = {
  next?: string
  previous?: string
}

type ViewStepConfig = {
  maxSteps: number
  showSteps: boolean
}

type ViewNavigationUtilReturn = {
  getViewFlow: (view: ViewName) => ViewFlow | undefined
  getStepForView: (view: ViewName) => number
  getStepConfig: () => ViewStepConfig
}

/**
 * Handle dynamic view navigation based on brand configuration.
 * Applies to CA and VD flows.
 */
const viewNavigationUtil = (): ViewNavigationUtilReturn => {
  const toRoutePath = (pageRoute: string | undefined): string | undefined => {
    if (!pageRoute) return undefined
    return pageRoute === 'intro' ? ROUTES.BASE : pageRoute
  }

  const getViewFlow = (view: ViewName): ViewFlow | undefined => {
    const flow = config.getFeatures()?.viewNavigation?.flow
    if (!flow) return undefined

    return {
      next: toRoutePath(flow[view]?.next),
      previous: toRoutePath(flow[view]?.previous),
    }
  }

  const getStepForView = (view: ViewName): number => {
    const viewNavigation = config.getFeatures()?.viewNavigation
    const steps = viewNavigation?.steps
    if (!steps || !Array.isArray(steps)) return 0

    const index = steps.indexOf(view)
    if (index === -1) return 0

    return index + (viewNavigation?.stepsOffset ?? 0)
  }

  const getStepConfig = (): ViewStepConfig => {
    const viewNavigation = config.getFeatures()?.viewNavigation
    const steps = viewNavigation?.steps ?? []
    const maxSteps = steps.length + (viewNavigation?.stepsOffset ?? 0) - 1
    const showSteps = viewNavigation?.showSteps === true

    return {
      maxSteps,
      showSteps,
    }
  }

  return {
    getViewFlow,
    getStepForView,
    getStepConfig,
  }
}

export const ViewNavigationUtil = viewNavigationUtil()
